import { UPDATE_LOADING } from '../actions/Loading';

export default function(state = {}, action) {
    const newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case UPDATE_LOADING:
            newState[action.payload.field] = action.payload.data;
            return newState;
        default:
            return state;
    }
}
